import { Flex, useColorModeValue, Image, Box, Tooltip, chakra, Icon, Badge, Circle, Text } from "@chakra-ui/react";
import { FC, ReactElement } from "react";
import { BsStar, BsStarFill, BsStarHalf } from "react-icons/bs";
import { FiShoppingCart } from "react-icons/fi";
import NumberFormat from "react-number-format";

interface ProductCardProps {
    isNew: boolean,
    imageUrl: string,
    name: string,
    price: number,
    sold: number,
    product: any,
    onClick: any
};

const ProductCard: FC<ProductCardProps> = ({ name, price, imageUrl, isNew, sold, product, onClick }): ReactElement => {
    return (
        <Flex p={0} w="full" alignItems="center" justifyContent="center" cursor={"pointer"} onClick={() => onClick(product)}>
            <Box
                bg={useColorModeValue('white', 'gray.800')}
                borderWidth="1px"
                rounded="lg"
                shadow="lg"
                position="relative">
                {isNew && (
                    <Circle
                        size="10px"
                        position="absolute"
                        top={2}
                        right={2}
                        bg="red.200"
                    />
                )}

                <Image
                    src={imageUrl}
                    alt={`Picture of ${name}`}
                    roundedTop="lg"
                />

                <Box px="4" py={2}>
                    {/*<Box d="flex" alignItems="baseline">*/}
                    {/*    {isNew && (*/}
                    {/*        <Badge rounded="full" px="2" fontSize="0.8em" colorScheme="red">*/}
                    {/*            New*/}
                    {/*        </Badge>*/}
                    {/*    )}*/}
                    {/*</Box>*/}
                    <Flex justifyContent="space-between" alignContent="center">
                        <Box
                            fontSize="md"
                            fontWeight="normal"
                            as="h4"
                            lineHeight="tight"
                            isTruncated>
                            {name}
                        </Box>
                        {/*<Tooltip*/}
                        {/*    label="Add to cart"*/}
                        {/*    bg="white"*/}
                        {/*    placement={'top'}*/}
                        {/*    color={'gray.800'}*/}
                        {/*    fontSize={'1.2em'}>*/}
                        {/*    <chakra.a href={'#'} display={'flex'}>*/}
                        {/*        <Icon as={FiShoppingCart} h={7} w={7} alignSelf={'center'} />*/}
                        {/*    </chakra.a>*/}
                        {/*</Tooltip>*/}
                    </Flex>

                    <Flex mt={2} justifyContent="space-between" alignContent="center">
                        <Box fontWeight={"bold"} color={"teal.800"}>
                            <NumberFormat displayType={'text'} value={price} thousandSeparator={true} prefix={"Rp "} />
                        </Box>
                        <Box color="gray.600" fontSize="sm">
                            {sold} terjual
                        </Box>
                    </Flex>
                </Box>
            </Box>
        </Flex>
    );
};

export default ProductCard;